var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbDownFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.309-340.001q-28.539 0-50.423-21.885-21.884-21.884-21.884-50.423v-64.614q0-6.231 1.307-13.461 1.308-7.231 3.923-13.462l114.615-270.46q8.616-19.231 28.846-32.462 20.231-13.231 42.077-13.231h323.846q29.923 0 51.115 21.193 21.193 21.192 21.193 51.115v377.767q0 14.461-5.923 27.807-5.923 13.346-15.77 23.192L413.616-108.694q-11.922 11.307-27.614 13.922-15.692 2.616-30.077-4.692-14.384-7.307-20.768-21.461-6.385-14.153-2.539-30.076l43.077-189H132.309Zm655.382-479.998q29.923 0 51.115 21.193 21.193 21.192 21.193 51.115v335.382q0 29.923-21.193 51.115-21.192 21.193-51.115 21.193h-8.462q-29.923 0-51.115-21.193-21.192-21.192-21.192-51.115v-335.767q0-29.923 21.192-50.923 21.192-21 51.115-21h8.462Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbDownFilled);
export default __webpack_public_path__ + "static/media/thumbDownFilled.0e680a46e699f4d3030cc6ff8f8a2b49.svg";
export { ForwardRef as ReactComponent };